// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2TO9D","content":"LoadingAlert_content__l8kFl"};